import { defineComponent as _defineComponent } from 'vue'
import {getQuestionnaire, submitQuestionnaire} from '@/api/miscellaneous';
import {ref} from 'vue';
import {Toast} from 'vant';

export default /*#__PURE__*/_defineComponent({
  __name: 'Questionnaire',
  setup(__props, { expose }) {
  expose();

const submitData = ref<any>({
    mobile: '',
    id: '',
});
const detail = ref<any>({});

const getQuestionnaireData = () => {
    getQuestionnaire().then((res: any) => {
        detail.value = res;
        submitData.value.id = res.id;
    });
};
getQuestionnaireData();

const submit = () => {
    if (submitData.value.mobile) {
        submitQuestionnaire(submitData.value).then(res => {
            submitData.value.mobile = '';
            Toast.success('提交成功');
        });
    } else {
        Toast.fail('请输入手机号码');
    }
};

const __returned__ = { submitData, detail, getQuestionnaireData, submit, getQuestionnaire, submitQuestionnaire, ref, Toast }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})